// extracted by mini-css-extract-plugin
export default {"tabs":"OWttZEPp65iHjUg9d3t7"};